import React, { useState, useRef, useEffect } from 'react';

// Each style has its own font/colour preview so users can see how it looks
const STYLES = [
  { id: 'minimal',    label: 'Minimal',     emoji: '🤍', preview: 'sample text', font: 'Arial, sans-serif',     weight: '400', color: '#f1f5f9', bg: 'transparent',            extra: { textTransform: 'lowercase' }, free: true },
  { id: 'highlight',  label: 'Word Highlight', emoji: '🔥', preview: 'sample TEXT', font: 'Arial Black, sans-serif', weight: '900', color: '#ffffff', bg: 'transparent',         extra: { textShadow: '2px 2px 0 #000', '--hl': '#FFFF00' }, free: false, html: <>SAMPLE <span style={{color:'#FFFF00'}}>TEXT</span></> },
  { id: 'hormozi',    label: 'Hormozi Bold', emoji: '🔥', preview: 'SAMPLE TEXT', font: 'Arial Black, sans-serif', weight: '900', color: '#ffffff', bg: 'transparent',         extra: { textShadow: '-3px -3px 0 #000, 3px -3px 0 #000, -3px 3px 0 #000, 3px 3px 0 #000, 0 4px 10px rgba(0,0,0,0.6)', letterSpacing: '2px', fontSize: '18px' }, free: false, html: <><span style={{color:'#FFFF00', fontSize:'19px', display:'inline-block', transform:'scale(1.1)'}}>BIG</span> WORDS</> },
  { id: 'capcut',     label: 'CapCut Pop-In', emoji: '⚡', preview: 'SAMPLE TEXT', font: 'Arial Black, sans-serif', weight: '900', color: '#ffffff', bg: 'transparent',         extra: { textShadow: '-2px -2px 0 #000, 2px -2px 0 #000, -2px 2px 0 #000, 2px 2px 0 #000, 0 3px 6px rgba(0,0,0,0.5)' }, free: false, html: <>SAMPLE <span style={{color:'#00FFFF', fontSize:'17px'}}>TEXT</span></> },
  { id: 'kinetic',    label: 'Kinetic Zoom', emoji: '🚀', preview: 'SAMPLE TEXT', font: 'Arial Black, sans-serif', weight: '900', color: '#ffffff', bg: 'transparent',         extra: { textShadow: '-2px -2px 0 #000, 2px -2px 0 #000, -2px 2px 0 #000, 2px 2px 0 #000' }, free: false, html: <>SAMPLE <span style={{color:'#FF60CB', fontSize:'18px', display:'inline-block'}}>TEXT</span></> },
  { id: 'fighthype',  label: 'Fight Hype',   emoji: '🥊', preview: 'SAMPLE TEXT', font: '"Bangers", "Impact", sans-serif', weight: '900', color: '#ffffff', bg: 'transparent',      extra: { letterSpacing: '2px', fontSize: '20px', textTransform: 'uppercase', WebkitTextStroke: '1px #FFE500', textShadow: '3px 3px 0 #CC0000, -1px 0 0 #FFE500, 1px 0 0 #FFE500, 0 -1px 0 #FFE500, 0 1px 0 #FFE500, -2px 0 0 #FFE500, 2px 0 0 #FFE500, 0 -2px 0 #FFE500, 0 2px 0 #FFE500' }, free: false },
  { id: 'karaoke',    label: 'Karaoke',      emoji: '🎤', preview: 'SAMPLE TEXT', font: 'Impact, sans-serif',     weight: '900', color: '#ffffff', bg: 'transparent',         extra: { textShadow: '-2px -2px 0 #000, 2px -2px 0 #000, -2px 2px 0 #000, 2px 2px 0 #000', letterSpacing: '1px' }, free: false, html: <>SAMPLE <span style={{background:'#FF0000', padding:'2px 6px', borderRadius:'4px', color:'white'}}>TEXT</span></> },
  { id: 'boldpop',    label: 'Bold Pop',     emoji: '💥', preview: 'SAMPLE TEXT', font: 'Impact, sans-serif',     weight: '900', color: '#FF60CB', bg: 'transparent',         extra: { textShadow: '3px 3px 0 #000, -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000', letterSpacing: '1px' }, free: false },
  { id: 'explosion',  label: 'Explosion',    emoji: '💣', preview: 'SAMPLE TEXT', font: 'Arial Black, sans-serif', weight: '900', color: '#ffffff', bg: 'transparent',         extra: { textShadow: '-2px -2px 0 #000, 2px -2px 0 #000, -2px 2px 0 #000, 2px 2px 0 #000, 0 4px 10px rgba(0,0,0,0.6)', letterSpacing: '2px' }, free: false, html: <>SAMPLE <span style={{color:'#FFFF00', fontSize:'17px', display:'inline-block', transform:'scale(1.15)'}}>TEXT</span></> },
  { id: 'gradient',   label: 'Gradient Pop', emoji: '✨', preview: 'SAMPLE TEXT', font: 'Arial Black, sans-serif', weight: '900', color: '#ffffff', bg: 'transparent',         extra: { textShadow: '-2px -2px 0 #000, 2px -2px 0 #000, -2px 2px 0 #000, 2px 2px 0 #000, 0 4px 8px rgba(0,0,0,0.5)', letterSpacing: '2px' }, free: false, html: <>SAMPLE <span style={{background:'linear-gradient(135deg,#FFD700,#FF6B35)', WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent', backgroundClip:'text', fontSize:'17px'}}>TEXT</span></> },
  { id: 'flash',      label: 'Flash',        emoji: '⚡', preview: 'WORD', font: 'Arial Black, sans-serif', weight: '900', color: '#FFD700', bg: 'transparent',         extra: { textShadow: '-3px -3px 0 #000, 3px -3px 0 #000, -3px 3px 0 #000, 3px 3px 0 #000, 0 4px 8px rgba(0,0,0,0.6)', fontSize: '22px', letterSpacing: '1px', textTransform: 'lowercase' }, free: false },
];

const StylePreview = ({ style }) => {
  const inner = style.html || style.preview;
  return (
    <div style={{
      display: 'inline-block',
      fontFamily: style.font,
      fontWeight: style.weight,
      color: style.color,
      background: style.bg,
      ...style.extra,
      fontSize: '15px',
      lineHeight: '1.4',
      whiteSpace: 'nowrap'
    }}>
      {inner}
    </div>
  );
};

const CaptionStylePicker = ({ value, onChange, userPlan, onLockedClick }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const isPaid = userPlan === 'pro' || userPlan === 'business';

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const selectedStyle = STYLES.find(s => s.id === value) || STYLES[0];

  const handlePick = (style) => {
    if (!style.free && !isPaid) {
      setOpen(false);
      onLockedClick && onLockedClick(style.label);
      return;
    }
    onChange(style.id);
    setOpen(false);
  };

  return (
    <div ref={ref} style={{ position: 'relative', flex: '1', minWidth: '180px', maxWidth: '260px' }}>
      <button
        type="button"
        onClick={() => setOpen(!open)}
        style={{
          width: '100%',
          background: 'rgba(30,41,59,0.9)',
          border: '1px solid rgba(124,58,237,0.4)',
          borderRadius: '8px',
          padding: '8px 12px',
          fontSize: '13px',
          fontWeight: '600',
          color: '#f1f5f9',
          cursor: 'pointer',
          outline: 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '8px'
        }}
      >
        <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span>{selectedStyle.emoji}</span>
          <StylePreview style={selectedStyle} />
        </span>
        <span style={{ fontSize: '10px', opacity: 0.6 }}>{open ? '▲' : '▼'}</span>
      </button>
      {open && (
        <div style={{
          position: 'absolute',
          top: 'calc(100% + 4px)',
          left: 0,
          right: 0,
          background: 'rgba(15,23,42,0.98)',
          border: '1px solid rgba(124,58,237,0.4)',
          borderRadius: '8px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.5)',
          maxHeight: '380px',
          overflowY: 'auto',
          zIndex: 1000,
          backdropFilter: 'blur(8px)'
        }}>
          {STYLES.map(style => {
            const locked = !style.free && !isPaid;
            return (
              <button
                key={style.id}
                type="button"
                onClick={() => handlePick(style)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: '100%',
                  padding: '12px 14px',
                  background: value === style.id ? 'rgba(124,58,237,0.18)' : 'transparent',
                  border: 'none',
                  borderBottom: '1px solid rgba(255,255,255,0.05)',
                  color: '#e2e8f0',
                  cursor: 'pointer',
                  textAlign: 'left',
                  transition: 'background 0.15s',
                  opacity: locked ? 0.65 : 1
                }}
                onMouseEnter={(e) => { if (!locked) e.currentTarget.style.background = 'rgba(124,58,237,0.12)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = value === style.id ? 'rgba(124,58,237,0.18)' : 'transparent'; }}
              >
                <span style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1, minWidth: 0 }}>
                  <span style={{ fontSize: '16px' }}>{style.emoji}</span>
                  <span style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1, minWidth: 0 }}>
                    <span style={{ fontSize: '12px', fontWeight: '600', color: '#94a3b8' }}>{style.label}</span>
                    <StylePreview style={style} />
                  </span>
                </span>
                {locked && (
                  <span style={{
                    fontSize: '10px',
                    fontWeight: '800',
                    padding: '3px 8px',
                    borderRadius: '6px',
                    background: 'rgba(251,191,36,0.15)',
                    color: '#fbbf24',
                    border: '1px solid rgba(251,191,36,0.3)',
                    flexShrink: 0,
                    marginLeft: '8px'
                  }}>🔒 PRO</span>
                )}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default CaptionStylePicker;
